<template>
  <div class="footer">
    <div class="info">
      Всего
      <template v-if="hasStrictTotal">
        {{ pagination.total }}
      </template>
      <template v-else-if="isAsync">
        <span>{{ rowEnd }}{{ rowEnd >= 50 ? '+' : '' }}</span>
      </template>
      <template v-else>
        <a href="#" @click.stop.prevent="changeToEagerPagination">{{ rowEnd }}<template v-if="pagination.total === true">+</template></a>
      </template>

      <button v-if="showClear" @click="filterClear" class="tiny" :style="{'background': isFiltered ? 'yellow !important' : null}" tooltip="Сброс всех фильтров и сортировок">Сброс</button>
      <button v-if="showEye" @click="showTableSettingsDialog" class="tiny" :style="{'background': hasHidden ? 'yellow !important' : null}" tooltip="Скрыть столбцы">
        <i class="fad fa-eye"></i>
      </button>

    </div>
    <div class="center">
      <slot name="info"></slot>
    </div>
    <div class="pagination">
      <doctu-lazy-pagination v-if="showLazyPaginate"
                             :pagination="paginationProxy"
                             :is-async="isAsync"
                             @input="updatePagination"
                             ref="lazyPagination"/>
      <doctu-eager-pagination v-else :pagination="paginationProxy" @input="updatePagination" ref="eagerPagination"/>
    </div>
  </div>
</template>

<script>
import DoctuTableLazyPagination from "./DoctuTableLazyPagination.vue";
import DoctuTableEagerPagination from "./DoctuTableEagerPagination.vue";
export default {
  name: "DoctuTableFooter",
  components: {
    'doctu-lazy-pagination': DoctuTableLazyPagination,
    'doctu-eager-pagination': DoctuTableEagerPagination
  },
  model: {
    prop: 'pagination',
    event: 'input'
  },
  props: {
    pagination: {
      required: true,
    },
    showClear: {
      type: Boolean,
      default: true
    },
    showEye: {
      type: Boolean,
      default: true
    },
    rowscount: {
      default: 0
    },
    pagesmax: {
      default: 100
    },
    isAsync: {
      default: false,
    },
  },
  computed: {
    paginationProxy: function () {
      return this.pagination;
    },

    showLazyPaginate: function () {
      return this.pagination.paginationType === 'lazy';
    },
    hasStrictTotal() {
      return this.pagination.paginationType !== 'lazy'
          && this.pagination.total !== true
          && this.pagination.total !== false
    },
    rowStart() {
      return (this.pagination.currentPage - 1) * this.pagination.perPage;
    },
    rowEnd() {
      return this.rowStart + this.rowscount;
    },

    hasHidden: function () {
      return this.$parent.hidden.length > 0;
    },
    isFiltered: function () {
        if (this.$parent.defaultFilter === null){
            return Object.keys(this.$parent.filter).length > 0;
        }
      return Object.keys(this.$parent.filter).length > 0 &&  JSON.stringify(this.$parent.filter) !== JSON.stringify(this.$parent.defaultFilter);
    }
  },
  methods: {
    changeToEagerPagination: function () {
      let pagination = JSON.parse(JSON.stringify(this.pagination));
      pagination.paginationType = 'full';
      this.updatePagination(pagination);
    },
    updatePagination: function (pagination) {
      this.$emit('input', pagination);
    },
    filterClear: function () {
      return this.$parent.filterClear();
    },

    showTableSettingsDialog: function () {
      this.$parent.showTableSettingsDialog();
    }
  },
  watch: {
  }
}
</script>
